var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1809_5544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4746 0H18.5254V6.15234H16.4746V0Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5762 0V8.20312H14.4238V0H8.27148V12.3047H26.7285V0H20.5762Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8047 22.5586H23.6523V14.3555H18.5254V28.7109H35V14.3555H29.8047V22.5586Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7031 14.3555H27.7539V20.5078H25.7031V14.3555Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30.7617H35V35H0V30.7617Z",
    fill: "#2027A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 14.3555H9.29688V20.5078H7.24609V14.3555Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4746 28.7109V14.3555H11.3477V22.5586H5.19531V14.3555H0V28.7109H16.4746Z",
    fill: "#2776CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1809_5544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/Production.01476a7cb908974d12513ed6072b3d7a.svg";
export { ForwardRef as ReactComponent };